import { GenericService } from '@/services/api/generic.service';
import { SurveyResultChart } from '@/custom/menicon/models';

export class MeniconSurveyResultChartsService extends GenericService<SurveyResultChart> {

  constructor(patientId: string) {
    super(`menicon/v1/patients/${patientId}/survey-result-charts`);
  }
}
